<template lang="html">

  <Modal 
    @close="$emit('close')"
    :footer="false"
    class="pe_difficulty-select"
  >
    <template #title>Choose difficulty:</template>
    <template #body>
      <div>
        <div 
          v-for="(puzzleId, levelName) in puzzleIds"
          :key="`a-btn-${levelName}`"
        >
          <button
            v-if="puzzleId"
            :class="['pe_btn pe_selected', getPuzzleState(puzzleId)]"
            @click="goToPuzzleRoute({ router: $router, id: puzzleId, desc: levelName })"
          >
            <span>{{ levelName }}</span>

            <component 
              v-bind:is="getPuzzleState(puzzleId)" 
              class="pe_logo"
            />       

          </button>

        </div>
      </div>
    </template>
  </Modal>

</template>

<script lang="js">

  import { mapState, mapGetters, mapActions } from 'vuex'
  import Modal from '@puzzleapps/shared/src/components/ui/Modal'

  import HourGlass from '@puzzleapps/shared/src/components/ui/icons/HourGlass'
  import Trophy from '@puzzleapps/shared/src/components/ui/icons/Trophy'
  import Play from '@puzzleapps/shared/src/components/ui/icons/Play'

  export default  {
    name: 'difficulty-select',
    props: ['date'], // date, format YYYY-MM-DD
    
    components: {
      Modal,
      'started': HourGlass,
      'completed': Trophy,
      'ready': Play,
    },

    mounted () {
      let data = this.archiveData[this.date]
      
      
      // fill puzzleIds from archive data
      data.forEach(elem => {
        // let levelName = 'easy'
        if (elem.puzzleId)
        {
          if (elem.description.includes('Level 1')) {
            this.puzzleIds.easy = elem.puzzleId
          }
          else if (elem.description.includes('Level 2')) {
            this.puzzleIds.medium = elem.puzzleId
          }
          else if (elem.description.includes('Level 3')) {
            this.puzzleIds.hard = elem.puzzleId
          }
          else if (elem.description.includes('Level 4')) {
            this.puzzleIds.difficult = elem.puzzleId
          }
          else if (elem.description.includes('Level 5')) {
            this.puzzleIds.insane = elem.puzzleId
          }
        }
      })
    },

    data () {
      return {
        puzzleIds: {
          easy: null,
          medium: null,
          hard: null,
          difficult: null,
          insane: null,
        }
      }
    },
    
    methods: {
      ...mapActions({
        setPuzzleId: 'game/setPuzzleId',
        goToPuzzleRoute: 'game/goToPuzzleRoute',
      }),

      goToRoute(id) {
        let path = {
          name: 'Game',
          params: {
            clientAppId: window.PE_CLIENTAPP_ID,
          },
          path: '/game'
        }

        this.setPuzzleId(id)

        this.singleRouterPath = path

        this.$router.push(this.singleRouterPath)
      }
    },
    
    computed: {
      ...mapState({
        archiveData: state => state.archive.data,
        gameType: state => state.game.type,
      }),

      ...mapGetters({
        getPuzzleState: 'archive/getLocalPuzzleState',
      }),

    }
}


</script>

<style scoped lang="scss">
#puzzleapp {
  .pe_difficulty-select {

    .pe_btn {
      justify-content: space-between;
      width: 11.4em;
      height: auto;
      border: 0;
      text-transform: capitalize;
      display: flex;
      margin: auto;
      align-items: center;
      margin-bottom: 0.5em;
      color: var(--default-font-color);
      font-weight: 400;
      
      span {
        transition: all 0.2s ease;
      }

      &:hover {
        background: #ececec;

        span {
          transform: translateX(4px);
        }
      }

      svg {
        width: 32px;
        height: 32px;                    

        &.pe_play {
          width: 22px;
          margin-right: 0.3em;
        }          
      }
    }
  

  }
}

</style>
